var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [
        _vm._v("Social Media Share URL's")
      ]),
      _c(
        "md-list",
        _vm._l(_vm.shareUrls, function(shareUrl, i) {
          return _c(
            "md-list-item",
            { key: i, staticClass: "list" },
            [
              _c(
                "md-input-container",
                [
                  _c("md-icon", {
                    attrs: {
                      "md-iconset": _vm.socialMediaNameMap[shareUrl.type].icon
                    }
                  }),
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.socialMediaNameMap[shareUrl.type].name || "") +
                        " share URL"
                    )
                  ]),
                  _c("md-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.shareUrls[i].url,
                      callback: function($$v) {
                        _vm.$set(_vm.shareUrls[i], "url", $$v)
                      },
                      expression: "shareUrls[i].url"
                    }
                  }),
                  _c(
                    "md-button",
                    {
                      attrs: { id: "btn-delete" },
                      on: {
                        click: function($event) {
                          return _vm.clearInput(i)
                        }
                      }
                    },
                    [_vm._v("X")]
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3eac6bac", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eac6bac","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/distribution/form-components/SnsShareForm.vue
// module id = 794
// module chunks = 0